import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { PayloadDto } from '@stores/payloads';

export const PayloadsActions = createActionGroup({
  source: 'Payloads',
  events: {
    Init: emptyProps(),
    'Get Payloads': props<{ tenantUuid: string }>(),
    'Get Payloads Success': props<{ payloads: readonly PayloadDto[] }>(),
    'Get Payloads Failure': props<{ error: unknown }>(),
    Clear: emptyProps(),
  },
});
